var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a", {
    class: _vm.bgImageClassName,
    attrs: { href: _vm.loginUrl, role: "button" },
    on: { click: _vm.onGoogleSignUp },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }